<template>
	<el-main class="portal-ai">
		<Banner />
    <AiIntro />
    <PlatformAdvantage />
		<CoreFunctionAndServices/>
		<ApplicationScope />
		<AiExample/>
	</el-main>
</template>

<script>
	import Banner from './AiPlatformBanner'
  import AiIntro from './AiIntro'
	import PlatformAdvantage from './PlatformAdvantage'
	import CoreFunctionAndServices from './CoreFunctionAndServices'
	import ApplicationScope from './ApplicationScope'
	import AiExample from './AiExample'
	export default {
		name: 'PortalAI',
		components: {
			Banner,
      PlatformAdvantage,
      CoreFunctionAndServices,
      ApplicationScope,
			AiIntro,
			AiExample
		},
		data() {
			return {
				dataimgs: [{
					id: 0,
					url: 'https://sso.mopaas.com/login',
					title: '人工智能平台',
					content: ['针对算法训练、模型托管的一站式服务平台'],
					btn: '立即体验',
					src1: require('@/assets/images/ai-banner.jpeg'),
					src2: require('@/assets/images/ai-banner-m.png'),
					platform:'感谢关注MoPaaS人工智能平台，平台暂未开放公有云服务，如需试用，请联系客服。'
				}],
				frameworks: [{
					id: 0,
					img: require('@/assets/images/rengong1.png'),
					name: 'TensorFlow',
					desc: 'TensorFlow 实现了数据流图，可由一系列图形描述的算法来处理，数据在该系统中的变化被称为“流”。数据流可用C++或Python编码后在CPU或GPU的设备上运行。'
				}, {
					id: 1,
					img: require('@/assets/images/rengong3.png'),
					name: 'Caffe',
					desc: '模型和组合优化通过配置实现，用户可根据需要在CPU处理和GPU处理之间进行切换， Caffe的高效性使其在实验研究和产业部署中的表现很完美。'
				}, {
					id: 2,
					img: require('@/assets/images/rengong2.png'),
					name: 'Torch',
					desc: '是基于Lua开发的，拥有一个庞大的生态社区驱动库包设计机器学习、计算机视觉、信号处理，并行处理，图像，视频，音频和网络等。'
				}, {
					id: 3,
					img: require('@/assets/images/rengong4.png'),
					name: 'Keras',
					desc: '旨在让用户进行快速的原型实验，让想法变为结果的过程最短；专精于深度学习，用Keras训练模型可以享受TensorFlow持续开发带来的性能提升。'
				}],
				flows: [{
					id: 1,
					img: require('@/assets/images/rengong5.png'),
					content: '创建AI训练环境'
				}, {
					id: 2,
					img: require('@/assets/images/rengong6.png'),
					content: '上传程序和数据'
				}, {
					id: 3,
					img: require('@/assets/images/rengong7.png'),
					content: '执行训练命令'
				}, {
					id: 4,
					img: require('@/assets/images/rengong8.png'),
					content: '展示评估报告'
				}],
				statistics: [{
					id: 0,
					defaultImg: require('@/assets/images/rengong9-1.png'),
					onImg: require('@/assets/images/rengong9.png'),
					img: require('@/assets/images/rengong15.png'),
					title: '极致性能',
					content: '各类框架运行于GPU服务器，GPU天生的超强计算能力，包含上千个计算单元，具有高并行、高吞吐、低时延等特点，在科学计算表现中性能比传统架构提高50倍。',
					active: true
				}, {
					id: 1,
					defaultImg: require('@/assets/images/rengong10-1.png'),
					onImg: require('@/assets/images/rengong10.png'),
					img: require('@/assets/images/rengong15-1.png'),
					title: '弹性灵活',
					content: '可随时根据需求创建深度学习训练环境，提供多种可选资源配置选择，可以满足多种业务场景需求。',
					active: false
				}, {
					id: 2,
					defaultImg: require('@/assets/images/rengong11-1.png'),
					onImg: require('@/assets/images/rengong11.png'),
					img: require('@/assets/images/rengong15-2.png'),
					title: '开箱即用',
					content: '开箱即支持 TensorFlow、Caffe、Torch等多种深度学习框架，无需购买其他资源，无需安装配置环境，无需进行性能调优，只需上传代码、数据和配置参数，即可快速提交训练任务。',
					active: false
				}, {
					id: 3,
					defaultImg: require('@/assets/images/rengong12-1.png'),
					onImg: require('@/assets/images/rengong12.png'),
					img: require('@/assets/images/rengong15-3.png'),
					title: '节约成本',
					content: '你无需预先采购、准备硬件资源，一次性购买，免除硬件更新带来的额外费用，有效降低基础设施建设投入，支持包年包月计费和按量计费，可以根据需要选择计费模式， 无需负担运维成本。',
					active: false
				}, {
					id: 4,
					defaultImg: require('@/assets/images/rengong13-1.png'),
					onImg: require('@/assets/images/rengong13.png'),
					img: require('@/assets/images/rengong15-4.png'),
					title: '服务保障',
					content: 'MoPaaS专业的运维团队提供 7×24 小时的运维服务，服务稳定可靠，无需关心硬件故障。',
					active: false
				}, {
					id: 5,
					defaultImg: require('@/assets/images/rengong14-1.png'),
					onImg: require('@/assets/images/rengong14.png'),
					img: require('@/assets/images/rengong15-5.png'),
					title: '安全防护',
					content: '不同用户之间资源全面隔离，保障您的数据安全，完善的网络监控服务保障您的网络安全。',
					active: false
				}],
				mediaSrc: require('@/assets/videos/MoPaaSai.mp4'),
				example: [{
					id: 0,
					src: require('@/assets/images/rengong20.png')
				}, {
					id: 1,
					src: require('@/assets/images/rengong21.png')
				}, {
					id: 2,
					src: require('@/assets/images/rengong23.png')
				}]
			}
		}
	}
</script>

<style>
	.rect-bg {
		position: absolute;
		left: 0;
		float: left;
		width: calc(100vw - 17px);
		min-width: 1200px;
		height: 2549px;
		-webkit-clip-path: polygon(45% 0, 100% 0, 36% 100%, 0 100%);
		clip-path: polygon(45% 0, 100% 0, 36% 100%, 0 100%);
		background: rgba(255,255,255,.3);
	}
  .portal-ai {
    position: relative; background-color: rgba(234,242,249,.22);
    overflow-y: hidden;
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/PortalAI.vue